import RENATOM_EXT_1 from "./RENATOM_EXT_1";
export default {
  RENATOM_EXT_1,
};
